import styled from 'styled-components';

export const YoutubePreviewWrapper = styled.button`
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    max-height: 144px;
    max-width: 256px;
    overflow: hidden;
    cursor: pointer;
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    line-height: 0;

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
`;

export const Thumbnail = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
